export var YEAR_DECADE_COUNT = 10;